<template>
  <v-row class="bg-section mx-0 py-3">
    <v-col cols="12">
      <v-card class="mt-0" flat>
        <v-card-title>Add or Remove Accesses</v-card-title>
        <v-card-text>
          <access-table
            v-model="electronicApplicationAccesses"
            v-model:new-access="newAccess"
            data-testid="eapp-access-table"
            :checkboxes="checkboxes"
            :delete-func="deleteAccess"
            :add-func="addAccess"
            :update-func="updateAccess"
          >
            <template #new-access>
              <generic-search
                v-model="newAccess"
                hide-details
                data-testid="access-advisor-search"
                label="Advisor"
                placeholder="Search Advisors"
                :prepend-inner-icon="mdiAccount"
                :composable="useAdvisorSearch"
              />
            </template>
          </access-table>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>

<script setup>
import AccessTable from "@/components/shared/AccessTable.vue";
import GenericSearch from "@/components/shared/GenericSearch.vue";

import { storeToRefs } from "pinia";

import { useEappViewStore } from "@/stores/eapp-view";
import { mdiAccount } from "@mdi/js";
import { ref } from "vue";
import { useAdvisorSearch } from "@/components/shared/search/advisor-search";

const eapp = useEappViewStore();
const { electronicApplicationAccesses } = storeToRefs(eapp);

const newAccess = ref(null);
const checkboxes = [
  {
    text: "Email",
    value: "email"
  },
  {
    text: "Case Access",
    value: "additionalCaseAccess"
  }
];

function deleteAccess(access) {
  return eapp.deleteEappAccess(access.id);
}
function addAccess(advisor) {
  return eapp.createEappAccess(advisor);
}
function updateAccess(access, attribute) {
  return eapp.updateEappAccess(access.id, attribute);
}
</script>
